
declare const cryptB: any
export class Secure {
  static key = ''
  static iv = ''

  private state: { key: string; iv: string; }

  constructor (
    public key?: string,
    public iv?: string,
    public pass?: string,
    public secret?: string
  ) {
    if (pass) {
      if (key) { this.key = Secure.key = this.decrypt(key, pass, iv || Secure.iv) }
      if (secret) { this.iv = Secure.iv = this.decrypt(secret, pass, iv || Secure.iv) }
    } else {
      if (key) { Secure.key = key }
      if (iv) { Secure.iv = iv }
    }
  }

  encrypt (message: string, key?: string, iv?: string) {
    try {
      return cryptB.encrypt(
        message,
        cryptB.getHashSha256(key || this.key || Secure.key, 32),
        iv || this.iv || Secure.iv
      )
    } catch (e) {
      return ''
    }
  }

  decrypt (message: string, key?: string, iv?: string) {
    try {
      return cryptB.decrypt(
        message,
        cryptB.getHashSha256(key || this.key || Secure.key, 32),
        iv || this.iv || Secure.iv
      )
    } catch (e) {
      return ''
    }
  }
}
